import Barba from 'barba.js';
import $ from 'jquery'

var mobileLinks = function() {

    const body = $('body');
    const clock = $('.clock-menu');
    const button = $('.hamburger');
    const menu = $('.menu-popover');

    var mobileLinks = Barba.BaseView.extend({
        namespace: 'mobilelinks',
        onEnter: function() {
            $('.header').removeClass('nav-up').addClass('nav-down');
        },
        onEnterCompleted: function() {

        },

        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    });

    mobileLinks.init();
}

module.exports = mobileLinks;



// WEBPACK FOOTER //
// ./resources/assets/js/barba/views/link-view.js